import { render, staticRenderFns } from "./profileFollower.vue?vue&type=template&id=71b79b2d&scoped=true"
import script from "./profileFollower.vue?vue&type=script&lang=js"
export * from "./profileFollower.vue?vue&type=script&lang=js"
import style0 from "./profileFollower.vue?vue&type=style&index=0&id=71b79b2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b79b2d",
  null
  
)

export default component.exports